import { callAccountGroups } from '@/api'
import { useQuery } from '@tanstack/react-query'

export const useFetchCurrentUserGroups = () => {
  return useQuery(['current-user-groups'], () => callAccountGroups(), {
    useErrorBoundary: true,
    retry: 3,
    onError: (error) => {
      console.error('Error loading user groups', error)
    },
    select: ({ data: groupsData }) => groupsData,
  })
}
